<footer class="global-footer">
  <div class="footer-left">
    &copy; {{ currentYear }} Rajya Krishi Utpadan Mandi Parishad, Uttar Pradesh. All Rights Reserved.
  </div>
  <div class="footer-right">
    <a href="javascript:void(0)">Privacy Policy</a>
    <a href="javascript:void(0)">Terms of Service</a>
  </div>
</footer>
